<template>
    <div class="animated fadeIn">
        <b-row v-if="loading">
            <b-col cols="12" md="6">
                <atom-spinner
                    :animation-duration="1000"
                    :size="60"
                    color="#ff1d5e"
                    class="float-right my-5"
                />
            </b-col>
        </b-row>
        <b-row v-if="!loading">
            <b-col cols="12" md="12">
                <component-header
                    title="View Service Request"
                    :hasSearch="false"
                    :hasReload="false"
                    :hasCreate="false"
                    :hasback="true"
                    @back-press="$router.push('/setup/service-request')"
                />
            </b-col>
            <b-col cols="12" md="12">
                <b-card>
                    <b-row>
                        <b-col cols="12" sm="6">
                            <b-form-group
                                label="Scope"
                                label-for="Scope"
                                :label-cols="3"
                            >
                                <b-form-input
                                    type="text"
                                    id="scope"
                                    placeholder="Scope"
                                    v-model="itemObj.Scope"
                                    disabled
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group
                                label="Category"
                                label-for="Category"
                                :label-cols="3"
                            >
                                <b-form-input
                                    type="text"
                                    id="category"
                                    v-model="itemObj.Category"
                                    placeholder="Category"
                                    disabled
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col sm="6">
                            <b-form-group
                                label="Topic"
                                label-for="Topic"
                                :label-cols="3"
                            >
                                <b-form-input
                                    type="text"
                                    id="topic"
                                    placeholder="Topic"
                                    disabled
                                    v-model="itemObj.topic"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group
                                label="Description"
                                label-for="Description"
                                :label-cols="3"
                            >
                                <b-form-input
                                    type="text"
                                    id="description"
                                    placeholder="Description"
                                    disabled
                                    v-model="itemObj.description"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12" md="12" class="add-subcategory-col">
                            <eb-button
                                class="btn btn-primary"
                                text="Add Sub Category"
                                icon="fa fa-plus-circle mr-1"
                                iconSide="left"
                                @click="category()"
                            ></eb-button>
                        </b-col>
                        <b-col cols="12" md="12">
                            <b-table
                                class="rounded-card mt-3"
                                :dark="dark"
                                :hover="hover"
                                :striped="striped"
                                :bordered="bordered"
                                :small="small"
                                :fixed="fixed"
                                responsive
                                id="my-table"
                                :items="subcategories"
                                :current-page="currentPage"
                                :per-page="perPage"
                                thead-class="header"
                                :fields="Columns"
                            ></b-table
                        ></b-col>
                    </b-row>

                    <b-row>
                        <b-col md="6">
                            <!-- <eb-button
                classic="mr-1 btn-primary"
                text="Back"
                @click="e => $emit('view', e)"
              ></eb-button> -->
                        </b-col>
                        <b-col cols="12" md="6">
                            <div class="d-flex justify-content-end">
                                <b-pagination
                                    v-model="currentPage"
                                    :per-page="perPage"
                                    :total-rows="subcategories.length"
                                    aria-controls="my-table"
                                    prev-text="Prev"
                                    next-text="Next"
                                    hide-goto-end-buttons
                                ></b-pagination>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import subcategory from "@/components/MasterSetup/ServiceRequest/Subcategory.vue";
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
export default {
    name: "Viewrequest",
    components: {
        ebButton,
        cInput,
        ebSelect,
        subcategory,
        ComponentHeader,
        AtomSpinner,
    },
    data: () => {
        return {
            itemObj: {},
            perPage: 5,
            striped: false,
            hover: true,
            bordered: true,
            small: false,
            dark: false,
            fixed: false,
            currentPage: 1,
            loading: false,
            Columns: [
                {
                    key: "Category",
                    sortable: true,
                },
                {
                    key: "Description",
                },
                {
                    key: "Scope",
                },

                {
                    key: "Severity",
                },
            ],
        };
    },
    computed: {
        subcategories() {
            let data = this.$store.getters["servicerequest/GetSubcategoryList"];
            let SubcategoryList = [];
            if (Array.isArray(data.data) && data.data.length > 0) {
                data.data.map((obj) => {
                    // for (let i = 0; i < obj.data.length; i++) {
                    let arrayObj = {
                        Category: obj.name,
                        Description: obj.description,
                        Scope: obj.scope,
                        Severity: obj.severity,
                        id: obj._id,
                        ...obj,
                    };
                    SubcategoryList.push(arrayObj);
                    // }
                });
                return SubcategoryList;
            } else {
                this.loading = false;
                return [];
            }
        },
        // userRole() {
        //   if (this.$store.getters["auth/getUserRole"]) {
        //     return this.$store.getters["auth/getUserRole"];
        //   } else {
        //     return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
        //   }
        // }
    },
    methods: {
        category() {
            this.$router.push({
                name: "Subcategory",
                params: { id: this.itemObj.id || this.itemObj._id },
            });
        },
        findItemById(list, id) {
            if (!list || !id) return null;
            const item = list.find((obj) => (obj._id || obj.id) === id);
            if (!item) return null;
            return {
                Category: item.name,
                Description: item.description,
                Scope: item.scope,
                Severity: item.severity,
                Status: item.status,
                id: item._id,
                ...item,
            };
        },
    },
    async mounted() {
        const id = this.$route.params.id;
        if (!id) {
            this.$router.replace("/setup/service-request");
            return;
        }
        this.loading = true;
        try {
            let list =
                this.$store.getters["servicerequest/GetServiceRequestList"];
            if (!list || list.length === 0) {
                await this.$store.dispatch(
                    "servicerequest/fetchServicerequestList",
                );
                list =
                    this.$store.getters["servicerequest/GetServiceRequestList"];
            }
            const item = this.findItemById(list, id);
            if (!item) {
                this.$toasted.error("Service request not found");
                this.$router.replace("/setup/service-request");
                return;
            }
            this.itemObj = item;
            await this.$store.dispatch(
                "servicerequest/fetchsubcategoryList",
                id,
            );
        } catch (error) {
            this.$toasted?.error(
                error?.message || "Failed to load service request",
            );
            this.$router.replace("/setup/service-request");
        } finally {
            this.loading = false;
        }
    },
};
</script>
<style scoped>
.fa-plus {
    border-top-right-radius: 10px;
    border-top-left-radius: 17px;
    border-bottom-left-radius: 17px;
    background-color: #f0f3f5;
}

.rounded-card {
    border-radius: 12px;
}

.add-subcategory-col {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
</style>
